// extracted by mini-css-extract-plugin
export var container = "_bq-1";
export var cornerButtonContainer = "_bq-6";
export var disabled = "_bq-2";
export var dragActive = "_bq-3";
export var fileContainer = "_bq-5";
export var hiddenInput = "_bq-4";
export var widthContainer = "_bq-0";